import React, { useState, useEffect } from "react";
import _ from "lodash";

import Box from "@mui/material/Box";

import { SIZE } from "@metacrm/metacrm-material-ui/dist/InputField";
import { ChromePicker } from "react-color";
import { InputField } from "@metacrm/metacrm-material-ui/dist/InputField";

import {
  StyledSettingItem,
  StyledSettingItemTitle,
  StyledSettingItemContent,
  StyledSettingItemChooseColorArea,
  StyledColorPickerPopover,
  StyledColorPickerCover,
  StyledColorDemoCycle,
  StyledSettingItemContentHint,
} from "./SettingItem.styles";
import useGetPagePermission from "hooks/useGetPagePermission";
import { useIntl } from "react-intl";

const SettingItem = ({
  colorSetting,
  onChange,
  control,
  errorsInfo,
  index,
  hideTitle,
}) => {
  const { name, color, hint, title } = colorSetting;
  const [open, setOpen] = useState(false);

  const handleChangeColor = (color) => {
    const e = { target: { value: color.hex, name: name } };
    onChange(e);
  };

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const { formatMessage } = useIntl();
  const pagePermission = useGetPagePermission();
  const { readonly, canEdit } = pagePermission("integration");

  return (
    <StyledSettingItem>
      {!hideTitle && (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box>
            <Box color="$555" fontSize={14} mb="4px">
              {_.startCase(
                formatMessage({
                  id: `global.label.${_.get(colorSetting, "title", name)}Color`,
                })
              )}
            </Box>
          </Box>
        </Box>
      )}

      <StyledSettingItemContent>
        <StyledSettingItemChooseColorArea sx={{ width: "200px" }}>
          <Box mr="8px">
            <InputField
              readonly={readonly}
              value={color}
              size={SIZE.LARGE}
              name={name}
              onChange={onChange}
              errors={_.get(errorsInfo, `${name}.message`)}
              rules={{
                required: {
                  value: true,
                  message: `${name} is required`,
                },
                pattern: {
                  value: new RegExp(`^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$`),
                  message: "Not valid color",
                },
              }}
              control={control}
            ></InputField>
          </Box>

          <Box position="relative">
            <StyledColorDemoCycle
              readonly={readonly}
              onClick={canEdit ? handleClick : null}
              color={color}
            />
            {open && canEdit && (
              <StyledColorPickerPopover>
                <StyledColorPickerCover onClick={handleClose} />
                <ChromePicker
                  color={color}
                  onChange={handleChangeColor}
                  name={name}
                  disableAlpha
                />
              </StyledColorPickerPopover>
            )}
          </Box>
        </StyledSettingItemChooseColorArea>
      </StyledSettingItemContent>
    </StyledSettingItem>
  );
};

export default SettingItem;
